import React from 'react';
import { StyledChevron } from '../BorderControlRequirement.styles';

const ChevronIconOpen = () => (
  <StyledChevron
    data-testid="chevronIconOpen"
    data-cy="chevronIconOpen"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.20993 12.349L15.8875 4.67135C16.0375 4.5214 16.0375 4.28147 15.8875 4.13152C15.7676 4.01156 15.5276 3.98157 15.3477 4.13152L8.59981 9.70978C8.26991 10.0397 7.73008 10.0397 7.40019 9.70978L0.652296 4.10153C0.472352 3.95158 0.232428 3.98157 0.112465 4.10153C-0.0374889 4.25148 -0.037489 4.49141 0.112465 4.64136L7.79007 12.319C7.85005 12.3789 7.91003 12.4089 8 12.4089C8.08997 12.4089 8.14995 12.4089 8.20993 12.349Z"
      fill="#1C1C1A"
    />
  </StyledChevron>
);

export default ChevronIconOpen;
